import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth12: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '108.5 82.8 105.1 98.4 102.2 112.8 98.2 126.7 92.3 141.1 89.9 146.4 84.2 160.5 80.9 171.9 72.6 185.2 70.1 188 65.9 190.3 59.9 191.8 57.6 191.4 53.4 190.1 47.7 186.9 40.5 182.3 32.7 177.4 31.4 174.9 30.8 171.5 30.2 167.7 30 162.4 28.9 154.2 24.2 151.4 20.7 147 13.7 130.1 10.1 117.4 8.8 109 8.4 99.5 8.6 83.8 8.6 77.3 9.5 64 12.6 54.1 23.6 45.8 45.6 39.5 47.9 39.3 52.8 38.9 58.3 39.1 64.4 39.1 70.5 41 74.7 41.8 77.9 41.6 81.3 40.8 96.1 40.8 102.6 44.3 108.5 53 108.5 82.8',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '108.5 82.8 105.1 98.4 102.2 112.8 98.2 126.7 92.3 141.1 89.9 146.4 84.2 160.5 80.9 171.9 72.6 185.2 70.1 188 65.9 190.3 59.9 191.8 57.6 191.4 53.4 190.1 47.7 186.9 40.5 182.3 32.7 177.4 31.4 174.9 30.8 171.5 30.2 167.7 30 162.4 28.9 154.2 24.2 151.4 20.7 147 13.7 130.1 10.1 117.4 8.8 109 8.4 99.5 8.6 83.8 8.6 77.3 9.5 64 12.6 54.1 23.6 45.8 45.6 39.5 47.9 39.3 52.8 38.9 58.3 39.1 64.4 39.1 70.5 41 74.7 41.8 77.9 41.6 81.3 40.8 96.1 40.8 102.6 44.3 108.5 53 108.5 82.8',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M70,118.8a13.9,13.9 0 1,1 -27.8,0a13.9,13.9 0 1,1 27.8,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M100.4,120.8c-53.7-33.5,8.3-38.4,8.3-38.4,0,0-8.3,38.4-8.3,38.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M10.3,116.5l-2.4-38c63,14,2.4,38,2.4,38Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M91.4,142.6h-.2s-5.3,12.3-5.3,12.3c-19-32-16.2-113.8-16.2-113.8l3.8.4,1.6.8,3.2.2,2.6-1.2,15-.2,8.5,4.9,4.4,6.9-.2,29.5-8.3,38.4-8.9,21.8h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.3,154.6h0c16.8-24.7,16.4-114.6,16.4-114.6l-4.8,1.6-16.4,4.6-10.5,8.3-3.2,8.3-2,15.8-.6,17.6,3,20.4,2.2,8.1,5.1,15.2,4,8.1,6.7,6.5h0Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.8,147h0l3.8,26.1c37.4,65,64.5-5.5,64.5-5.5l3.2-26.5-2.4,5.3-5.7,14.1-3.3,11.4-8.3,13.3-2.5,2.8-4.2,2.3-6,1.5-2.3-.4-4.2-1.3-5.7-3.2-7.2-4.6-7.8-4.9-1.3-2.5-.6-3.4-.6-3.8-.2-5.3-1.1-8.2-4.7-2.8-3.5-4.4h0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '109.2 64.1 9.7 64.1 14.2 53.4 22.4 47 29.5 43.9 37.4 41.2 46.6 39.1 60.4 39.1 72.6 41.1 74.4 42.3 79 42 80.7 41.1 95.3 41.2 101.2 44.3 105.3 48.4 108.5 53.2 109.2 64.1',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.3 91.1 18.4 106.5 23.5 85 30.2 111.2 38.9 84.3 47.1 111.2 56.2 84.7 64.6 111.2 73.7 82.9 81.1 109.9 90.8 82.9 93.8 105.5 106.3 91.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'50.8 190.5 61.7 197.2 51.8 203.1 61.5 209.2 51.8 214.9 63 221.8 53.6 227.4 62.5 232.9 53.1 238.5 62.8 244.6 52.9 250.5 62.2 256.2 52.1 262.1 60.7 267.4 50.9 273.3 61.3 279.7 49.9 286.5 60 292.7 48.8 299.4 59 305.9 47.9 312.5 59.8 319.8 49.6 325.9 57.2 334.5 43.9 348',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'35.6 254.4 38.2 263.1 41.2 253.9 44.3 262.3 48 254.7 52.6 263.6 56.6 252.8 61.5 263.1 66.3 252.8 70.4 262.3 74.6 253.1',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '107.2 96.5 108.2 101.9 107.5 106.8 105.8 111.4 98.8 118.3 91.1 128 86.2 133.2 81.3 137.7 76.6 140.7 70.2 143.8 65.5 145.2 62.3 145.4 57.6 145.4 50.1 144.2 46.8 142.4 42.6 138.4 39.3 135.3 34.2 134.6 29.5 132.5 22.1 126.4 16.2 120.4 10.6 114.5 8.5 109.6 6.8 103.9 6.4 101.1 7.3 94.6 14.6 86.6 29 76.6 38.6 71.4 44.7 69.1 51.1 66.8 56.9 66.3 62.8 66.7 70.2 68.9 79.8 72.8 86.6 75.6 97.4 83.8 104.6 92.5 107.2 96.5',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '13.7 87.9 7.5 94.6 6.4 98 6.5 102.9 8.4 109.3 11.9 115.3 101.6 115.3 107.5 106.7 107.2 96.6 100.9 88.1 13.7 87.9',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M101.6,115.2c-38.4-14.2-.7-27.2-.7-27.2l6.2,8.6.4,10.1-5.9,8.6h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M12,115.3c44.8-15,1.8-27.4,1.8-27.4l-6.2,6.7-1,3.4v4.8s1.9,6.5,1.9,6.5l3.4,6h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107.7,107.1c-52.6-13.5-100.5-.5-100.5-.5,0,0-.8-2.1-.9-2.1v-6.7s.8-2,.8-2l1.7-3.3,6.3-5.9,8.1-5.7,7.8-5.5,7.3-3.9,7.3-3.3,7-1.9h6.6c2,0,3.5.6,3.5.6l4.5.8,5.8,1.9,6.6,2.7,7.1,3.8,6.6,4.6,5.1,4.8,5.1,5.1,3.8,6,.3,10.3v.2Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.4,110.8l2.4-3.9c-49.5-14.5-100.5-.5-100.5-.5l.9,2.8,2.2,4.3,5.3,6.6,8,7.8s10,6.5,10.4,6.5,1.8,0,2.3.1,2.6.6,3.1.6,1.8,2,2.2,2,7.9,6.8,7.9,6.8c0,0,4.1,1.5,4.1,1.4h11.6s3.4-1.1,4.3-1.4,10.2-5.3,10.2-5.3l13.2-13,12.2-14.7h.2Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.4,85.5h53.5c-26.1-20.8-53.5,0-53.5,0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'6.8 97.5 17.2 110.8 22.4 92.3 29.4 114.9 38.3 91.7 46.8 114.9 56.1 92 64.8 114.9 74.1 90.6 81.8 113.8 91.7 90.6 94.8 110 107.7 98.1',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '97.7 389.5 102.9 404.5 108.9 427.6 111 440.6 111.2 453.6 110.7 458.6 108.9 462.9 104.7 467.1 100.7 470.9 94.7 472.6 88.4 473.4 81.4 473.4 76.7 473.9 73.1 474.1 67.4 475.9 60.1 476.9 53.9 476.9 33.6 473.6 30.1 473.9 17.6 466.1 11.8 453.1 10.8 443.6 11.3 405.3 11.8 397.3 18.1 376.8 19.6 373.2 21.8 367.5 25.6 361.2 29.3 356.7 33.3 355.2 38.3 353 46.4 350.5 53.1 349.5 58.9 349 65.1 350.5 71.1 355 78.7 361 82.7 367 91.4 375.5 97.7 389.5',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '97.7 389.5 102.9 404.5 108.9 427.6 111 440.6 111.2 453.6 110.7 458.6 108.9 462.9 104.7 467.1 100.7 470.9 94.7 472.6 88.4 473.4 81.4 473.4 76.7 473.9 73.1 474.1 67.4 475.9 60.1 476.9 53.9 476.9 33.6 473.6 30.1 473.9 17.6 466.1 11.8 453.1 10.8 443.6 11.3 405.3 11.8 397.3 18.1 376.8 19.6 373.2 21.8 367.5 25.6 361.2 29.3 356.7 33.3 355.2 38.3 353 46.4 350.5 53.1 349.5 58.9 349 65.1 350.5 71.1 355 78.7 361 82.7 367 91.4 375.5 97.7 389.5',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.6,401.7h39.7c-20.7-89.7-39.7,0-39.7,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.5,437.7l-8.2-35c-42.8,24.9,8.2,35,8.2,35Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M10.1,404.3l.4,36.5c47.4-14.1-.4-36.5-.4-36.5Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.7,439l-98.7,1.1s-.4,3.7-.5,3.7v2.6s.3,2.7.3,2.7l.4,2.6,1,3.8,1.4,3.4,1.9,3.2s1.7,3.3,1.8,3.8,2.5,3.1,3.3,3.2,2.2,1.9,2.2,1.9c0,0,3.8,2,4.8,2.2s4,1.4,4,1.4c0,0,5.2,1,6.2,1s4.7.7,5.2.7,5.2.3,5.8.1,4.8.5,4.8.5c0,0,3.7.1,4.4.1s4,.2,4.4-.1,1.6-.7,1.6-.7l3.7-.8s3.1-.9,3.8-1,4.1-.5,4.1-.5c0,0,1.9-.4,2.5-.4s4.2-.1,4.2-.1c0,0,3.6-.3,3.6-.4h4.1s4.5.5,4.9.3,3.6-.7,3.6-.7l4.8-3.3,4.8-5.2,2.3-4.2.5-7.4-1.1-13.4h-.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.8,376.3c-15.2,18.3-14.9,97.6-14.9,97.6,0,0,3.8-.1,4.2-.1s5.1-.6,5.6-.7,5.5-.4,6-.4h5.5s4.1-2.7,4.7-3.2,4.8-3.8,4.8-3.8l3.6-6.4.7-9.3-1.6-12.5-3.2-15.8-3.4-15.3-4.9-14.2-7-15.8h-.1Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,375c19.3,15.3,24,100.3,24,100.3l-4-.4-4.7-.7-5.6-1-11.4-6.4-5.5-11.8-1.6-9.3-.3-11.5-.4-19.9s.7-4.8.8-4.8v-6s1.5-7,1.5-7l2.3-9,4.8-12.5h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.6,364.1c-31.1-45.6-71.5-4.7-71.5-4.7v17.4s3.7-9.3,3.7-9.3l3.8-6.3,3.7-4.5,9-3.7,8.1-2.5,12.5-1.5,6.2,1.5,13.6,10.5,4,6,8.7,8.5-1.8-11.4Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'106.9 423.7 94.8 410.2 91.9 432.3 82.3 406 75.1 432.3 66.2 404.6 58.1 430.6 49.2 404.6 41.3 430.9 32.7 404.6 26.1 430.2 21.2 409.2 11.3 424.2',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'38.3 156.5 39.5 167.8 48.2 170.1 43.7 178.1 54.2 185 42 193.2 53.3 200.6 42.8 207.7 54.4 215.2 44 222.2 55.7 229.8 45.1 237 55.1 243.6 46.3 249.5 56.6 256.1 47.1 262.5 57.3 269.1 47.3 275.9 57 282.2 47.8 288.3 57.5 294.6 45.9 302.3 55.9 308.7 45.9 315.5 56.1 322.1 44.9 329.6 55.7 336.7 43.7 344.9 54.2 351.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'73.1 276.1 68.1 265.3 63.1 276.4 57.2 264.3 51.2 276.4 46.2 263.7 40.8 274.3 36.2 265.3 32.3 275.1 28.7 264.3 25.6 274.6',
			],
		},
	},
};
